import { Component, ViewEncapsulation, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { ModalDialogComponent } from "../common/components/modal-dialog/modal-dialog.component";
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import {PromtUserComponent} from '../prompt-user/promt-user.component'
import { MatCardModule } from '@angular/material/card';
import { DashboardService } from '../../services/shared/dashboard.service';
import { ButtonComponent } from '../common/components/button/button.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [PromtUserComponent,RouterLink, RouterLinkActive, MatIconModule, MatMenuModule, MatFormFieldModule, MatCheckboxModule, MatInputModule, MatSelectModule, MatButtonModule, MatDividerModule, MatTableModule, MatGridListModule, MatPaginator, MatPaginatorModule, FormsModule, ModalDialogComponent, MatCardModule, CommonModule, ButtonComponent]
})
export class DashboardComponent implements OnInit {

  roles = [{name : 'user' , id : 4},{name : 'creator' , id : 3},{name : 'curator' , id : 2},{name : 'Admin' , id : 1}]
  selectedValue: number = this.roles[0].id;
  userid: any;
  user_role: any;
  urlParams: any;
  //displayedColumns: string[] = ['select', 'project_name', 'product_name', 'topic_name', 'created_by', 'created_at', 'status', 'action'];
  ngOnInit(): void {
    // this.dashborad.currentData.subscribe((data) => {
    //   this.userid = data
    //   if (this.userid == 1) {
    //     this.user_role = "admin"
    //   }
    //   else if (this.userid == 2) {
    //     this.user_role = "curator"
    //   }
    //   else if (this.userid == 3) {
    //     this.user_role = "creator"
    //   }
    //   else if (this.userid == 4) {
    //     this.user_role = "user"
    //   }
    //   this.selectedValue = this.userid
    // });
    this.user_role = this.dashborad.user_role
    this.userid = this.dashborad.user_id;
    // this.dashborad.role.next(this.user_role);
   // this.dashborad.getSelectedRole().subscribe(val => val !== 0 ? this.selectedValue = val : this.selectedValue);
  }
  constructor ( private dashborad : DashboardService , private router : Router, private activatedRoute : ActivatedRoute) {
    
    this.activatedRoute.queryParams.subscribe((params) => {
      this.urlParams = params;
    })

    if(this.urlParams && this.urlParams['role'] === 'creator'){
      this.selectedValue = this.urlParams['role']
    }
  }
  onChange(event : any) {
    this.selectedValue = +event.target.value;
    this.dashborad.changeData(this.selectedValue);
    
  }
  requestPrompt(event: any) {
    // window.open('https://forms.office.com/pages/responsepage.aspx?id=Wft223ejIEG8VFnerX05yVdwx7jKy6VGsZgzlQpj2-9UM1JRMFdNU0tBM0w2NTdOT0JVR05VVjFaRy4u&origin=QRCode', '_blank');
    window.open('https://forms.office.com/e/dj7DDGhHy1', '_blank');
  }
 
  createPrompt(event: any) {
    this.router.navigateByUrl('/home/prompt-create?role='+this.user_role+'&create=Y');
  }

}
